import { Stack, Typography } from '@mui/material';

export function SnapshotSelectionHeader(props: { fileName: string }) {
  const { fileName } = props;

  return (
    <Stack
      direction='row'
      alignItems='center'
      margin='16px 40px'
      flexWrap='wrap'
    >
      <Typography variant='body1' marginRight='6px'>
        Select a snapshot to restore
      </Typography>
      <Typography className='font-semibold'>{fileName}</Typography>
    </Stack>
  );
}
